import React from 'react';
import { Box, MenuItem, Paper, TextField, Tooltip, IconButton, Typography } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { EMPRESAS } from '../constants/operatingModes';

const BarraFiltros = ({ empresa, onEmpresaChange, onRefresh, loading, total }) => {
  return (
    <Paper
      variant="outlined"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 2,
        p: 2,
        mb: 2,
        borderRadius: 2,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
        <TextField
          select
          size="small"
          label="Empresa"
          value={empresa}
          onChange={(e) => onEmpresaChange(Number(e.target.value))}
          sx={{ minWidth: 160 }}
        >
          {EMPRESAS.map((op) => (
            <MenuItem key={op.value} value={op.value}>
              {op.label}
            </MenuItem>
          ))}
        </TextField>

        <Typography variant="body2" color="text.secondary">
          {total} terminal{total === 1 ? '' : 'es'}
        </Typography>
      </Box>

      <Tooltip title="Refrescar">
        <span>
          <IconButton onClick={onRefresh} disabled={loading} color="primary">
            <RefreshIcon />
          </IconButton>
        </span>
      </Tooltip>
    </Paper>
  );
};

export default BarraFiltros;
